module.exports = __webpack_public_path__ + "img/home_btn.391c5e8a.png";